"use client";
import { Link, type LinkProps } from "@ui/components/navigation/link/Link";
import { Link as LocaleLink } from "i18n/routing";
import { type ComponentProps, forwardRef } from "react";

type NextIntlLinkProps = ComponentProps<typeof LocaleLink>;

export type NextLinkProps = NextIntlLinkProps &
    LinkProps & {
        locale?: string;
    };

export const NextLink = forwardRef<HTMLAnchorElement, NextLinkProps>((props, ref) => {
    const { prefetch = false, ...rest } = props;
    return <Link as={LocaleLink} ref={ref} prefetch={prefetch} {...rest} />;
});

NextLink.displayName = "NextLink";
